export const classroomsOptions = [
  { value: 'ps', label: 'Petite section' },
  { value: 'ms', label: 'Moyenne Section' },
  { value: 'gs', label: 'Grande Section' },
  { value: 'cp', label: 'CP' },
  { value: 'ce1', label: 'CE1' },
  { value: 'ce2', label: 'CE2' },
  { value: 'cm1', label: 'CM1' },
  { value: 'cm2', label: 'CM2' },
  { value: 'adaptation', label: 'Adaptation' },
]

export const genderOptions = [
  { label: 'Madame', value: 'madame' },
  { label: 'Monsieur', value: 'monsieur' },
]
